export async function loader({ params }) {
    const id_lanzar_campania= params.id
    return { id_lanzar_campania };
}
